import gql from 'graphql-tag';

export const signupReservationCreate = gql`
  mutation signupReservationCreate($input: SignupReservationCreateInput!) {
    signupReservationCreate(input: $input) {
      signup_reservation {
        id
        type
        email_address
        username
      }
    }
  }
`;
